@if (isSuccess) {
  <div class="subscriberForm subscriberForm--success">
    <p class="text-center font-medium">{{ 'subscriberForm.success' | transloco }}</p>
  </div>
} @else {
  <form [formGroup]="subscriberForm" (ngSubmit)="onSubmit()" class="subscriberForm" novalidate>
    <p-floatlabel variant="in" class="subscriberForm__input">
      <input
        pInputText
        id="company_name"
        formControlName="company_name"
        autocomplete="organization"
        fluid
      />
      <label for="company_name">{{ 'subscriberForm.companyName' | transloco }}</label>
    </p-floatlabel>

    <p-floatlabel variant="in" class="subscriberForm__input">
      <input pInputText id="contact_name" formControlName="name" autocomplete="name" fluid />
      <label for="contact_name">{{ 'subscriberForm.contactName' | transloco }}</label>
    </p-floatlabel>

    <p-floatlabel variant="in" class="subscriberForm__input">
      <input
        pInputText
        id="email"
        formControlName="email"
        type="email"
        autocomplete="email"
        fluid
      />
      <label for="email">{{ 'subscriberForm.email' | transloco }}</label>
    </p-floatlabel>

    <div class="subscriberForm__input">
      <d2d-phone-input [controlForm]="subscriberForm.get('phone')!" />
    </div>

    @if (isError) {
      <small class="text-red-500">{{ 'subscriberForm.error' | transloco }}</small>
    }

    <button
      class="subscriberForm__button"
      pButton
      type="submit"
      severity="contrast"
      size="large"
      [loading]="isLoading"
      [disabled]="isLoading"
    >
      {{ 'subscriberForm.submit' | transloco }}
    </button>
  </form>
}
